// 商城菜单接口 
import axios from 'axios'

// 商城订单
// 订单列表(分页)
export function getOrderSmall(data) {
  return axios({
    url: `/api/oms/orderSmallProduct/listPage`,
    method: 'get',
    params: data
  })
}
// 订单列表查询(不分页)
export function getOrderAllSmall(data) {
  return axios({
    url: `/api/oms/orderSmallProduct/list`,
    method: 'get',
    params: data
  })
}
// 通过支付订单号获取商品信息
export function getOrderProductSmall(paySn) {
  return axios({
    url: `/api/oms/orderSmallProduct/orderProduct?paySn=${paySn}`,
    method: 'get'
  })
}
// 通过订单号查询商城订单
export function getOrderSnSmall(orderSn) {
  return axios({
    url: `/api/oms/orderSmallProduct/orderByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 通过订单号获取工单
export function orderWorkBySmall(orderSn) {
  return axios({
    url: `/api/oms/orderSmallProduct/workByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}
// 订单新增
export function addOrderSmall(data) {
  return axios({
    url: `/api/oms/orderSmallProduct/insert`,
    method: 'post',
    data
  })
}
// 订单修改
export function updateOrderSmall(data) {
  return axios({
    url: `/api/oms/orderSmallProduct/update`,
    method: 'post',
    data
  })
}
//通过订单号获取寄出物流轨迹 ↓↓一样的
export function expressDetailSmall(orderSn) {
  return axios({
    url: `/api/oms/orderSmallProduct/expressByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}

// 通过订单号获取寄出物流状态
export function expressStatusSmall(orderSn) {
  return axios({
    url: `/api/oms/orderSmallProduct/expressOrderByOrderSn?orderSn=${orderSn}`,
    method: 'get'
  })
}

// 商城商品
// 根据渠道ID获取商品
export function getChannelIdSmall(id) {
  return axios({
    url: `/api/pms/smallProduct/selectByChannelId?id=${id}`,
    method: 'get'
  })
}
// 商品列表(分页)
export function getProductSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/listPage`,
    method: 'get',
    params: data
  })
}
// 商品查询(不分页)
export function getProductAllSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/list`,
    method: 'get',
    params: data
  })
}
// 新增商品
export function addProductSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/insert`,
    method: 'post',
    data
  })
}
// 商品修改
export function updateProductSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/update`,
    method: 'post',
    data
  })
}
// get上传图片接口file
export function productUploadFileSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/uploadFile`,
    method: 'get',
    params: data
  })
}
// post上传图片接口file
export function productUploadFilesSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/uploadFile`,
    method: 'post',
    data
  })
}
// 商品库上传详情图片/轮播图
// get上传详情图片接口file
export function uploadDetailSmallGet(data) {
  return axios({
    url: `/api/pms/smallProduct/uploadDetailFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post上传详情图片接口file
export function uploadDetailSmallPost(data) {
  return axios({
    url: `/api/pms/smallProduct/uploadDetailFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// get上传轮播图片接口file
export function uploadCarouseSmallGet(data) {
  return axios({
    url: `/api/pms/smallProduct/uploadCarouselFile`,
    method: 'get',
    params: data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// post上传轮播图片接口file
export function uploadCarouseSmallPost(data) {
  return axios({
    url: `/api/pms/smallProduct/uploadCarouselFile`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// post图片删除 filePath,ossFolderName
export function deleteFilesSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/deleteFile`,
    method: 'post',
    params: data
  })
}
// get图片删除filePath,ossFolderName
export function deleteFileSmall(data) {
  return axios({
    url: `/api/pms/smallProduct/deleteFile`,
    method: 'get',
    params: data
  })
}
// 列举图片
export function listFileSmall(ossFolderName) {
  return axios({
    url: `/api/pms/smallProduct/listFile?ossFolderName=${ossFolderName}`,
    method: 'get'
  })
}

// 商品分类
// 商品分类列表(分页)
export function getCategorySmall(data) {
  return axios({
    url: `/api/pms/smallProductCategory/listPage`,
    method: 'get',
    params: data
  })
}
// 商品分类查询(不分页)
export function getCategoryAllSmall(data) {
  return axios({
    url: `/api/pms/smallProductCategory/list`,
    method: 'get',
    params: data
  })
}
// 新增商品分类
export function addCategorySmall(data) {
  return axios({
    url: `/api/pms/smallProductCategory/insert`,
    method: 'post',
    data
  })
}
// 删除商品分类
export function deleteCategorySmall(id) {
  return axios({
    url: `/api/pms/smallProductCategory/delete?id=${id}`,
    method: 'get'
  })
}
// 修改商品分类
export function editCategorySmall(data) {
  return axios({
    url: `/api/pms/smallProductCategory/update`,
    method: 'post',
    data
  })
}

// 商城用户列表
export function getMember(data) {
  return axios({
    url: `/api/ums/member/listPage`,
    method: 'get',
    params: data
  })
}
// 通过onlineOpenId获取线上用户
export function getOnlineOpenId(onlineOpenId) {
  return axios({
    url: `/api/ums/member/listByOnlineOpenId?onlineOpenId=${onlineOpenId}`,
    method: 'get'
  })
}
// 通过storeOpenId获取门店用户
export function getStoreOpenId(storeOpenId) {
  return axios({
    url: `/api/ums/member/listByStoreOpenId?storeOpenId=${storeOpenId}`,
    method: 'get'
  })
}

// 通过类型、手机号、openid查询用户
export function getPhoneOpenId(loginType, openId, phone) {
  return axios({
    url: `/api/ums/member/listByPhoneAndOpenId?loginType=${loginType}&openId=${openId}&phone=${phone}`,
    method: 'get'
  })
}

// 通过手机号查询用户
export function getUserPhone(phone) {
  return axios({
    url: `/api/ums/member/listByPhone?phone=${phone}`,
    method: 'get'
  })
}
// 新增补款记录
export function insertSupply(data) {
  return axios({
    url: `/api/oms/orderSupply/insert`,
    method: 'post',
    data
  })
}
// 查询补款记录
export function supplyList(data) {
  return axios({
    url: `/api/oms/orderSupply/listPage`,
    method: 'get',
    params: data
  })
}
// 用户修改
export function updateMember(data) {
  return axios({
    url: `/api/ums/member/update`,
    method: 'post',
    data
  })
}
// 新增用户
export function insertMember(data) {
  return axios({
    url: `/api/ums/member/insert`,
    method: 'post',
    data
  })
}
// 商城用户地址列表
export function getReceiveAddr(data) {
  return axios({
    url: `/api/ums/receiveAddress/listPage`,
    method: 'get',
    params: data
  })
}
// 充值记录列表(分页)
export function getRecharge(data) {
  return axios({
    url: `/api/ums/recharge/listPage`,
    method: 'get',
    params: data
  })
}
// 新增充值记录
export function insertRecharge(data) {
  return axios({
    url: `/api/ums/recharge/insert`,
    method: 'post',
    data
  })
}

// 余额充值微信推送
export function rechargeWxSend(data) {
  return axios({
    url: `/api/ums/member/rechargeWxSend`,
    method: 'get',
    params: data
  })
}
// 余额退款微信推送
export function refundWxSend(data) {
  return axios({
    url: `/api/ums/member/refundWxSend`,
    method: 'get',
    params: data
  })
}

// 根据渠道ID获取商品
export function getChannelIdSmallChannelRel(id) {
  return axios({
    url: `/api/pms/smallProductChannelRel/selectByChannelId?id=${id}`,
    method: 'get'
  })
}
// 渠道商品列表(分页)
export function getProductSmallChannelRel(data) {
  return axios({
    url: `/api/pms/smallProductChannelRel/listPage`,
    method: 'get',
    params: data
  })
}
// 渠道商品查询(不分页)
export function getProductAllSmallChannelRel(data) {
  return axios({
    url: `/api/pms/smallProductChannelRel/list`,
    method: 'get',
    params: data
  })
}
// 新增渠道商品
export function addProductSmallChannelRel(data) {
  return axios({
    url: `/api/pms/smallProductChannelRel/insert`,
    method: 'post',
    data
  })
}
// 渠道商品修改
export function updateProductSmallChannelRel(data) {
  return axios({
    url: `/api/pms/smallProductChannelRel/update`,
    method: 'post',
    data
  })
}
// 源渠道商品拷贝至目标渠道
export function sourceCopyTargetSmall(source, target, targetName) {
  return axios({
    url: `/api/pms/smallProductChannelRel/sourceCopyTargetByChannelId?sourceChannelId=${source}&targetChannelId=${target}&targetChannelName=${targetName}`,
    method: 'get'
  })
}
// get上传图片接口file
export function productUploadFileSmallChannelRel(data) {
  return axios({
    url: `/api/pms/smallProductChannelRel/uploadFile`,
    method: 'get',
    params: data
  })
}
// post上传图片接口file
export function productUploadFilesSmallChannelRel(data) {
  return axios({
    url: `/api/pms/smallProductChannelRel/uploadFile`,
    method: 'post',
    data
  })
}